/**
 * Created by Sergii on 4/27/2017.
 */
import { connect } from 'react-redux';
import {TestDetailsWnd} from '../components/TestDetailsWnd.jsx';
import * as actions from '../actions/index';
import { MessageBoxTypes } from '../const/TestResultsConst';

const mapStateToProps = (state, ownProps) => {
    // var test = state.currentTestId ? state.tests.filter(test => test.id === state.currentTestId )[0] : state.testDetails.test;
    var test = state.testDetails.test;
    var labs = state.labs;
    var lab = labs && test && test.lab ? labs.filter(lab => lab.name === test.lab) : undefined;
    var testOrdered = lab && lab[0] && lab[0].tests && test.testOrdered ? lab[0].tests.filter(tests => tests.name === test.testOrdered) : undefined;
    var errors = state.testDetails.errors;
    var fileNames = state.testDetails.files.map(file => file.name);
    var ambryError = state.ambryStatus ? state.ambryStatus !== '0' : true;

    var props = {
        show: ownProps.show,
        saving: state.testDetails.saving,
        test: test,
        labs: labs ? labs.map(lab => lab.name) : [],
        testsOrdered: lab && lab[0] && lab[0].tests ? lab[0].tests.map(test => test.name) : [],
        genes: testOrdered && testOrdered[0] && testOrdered[0].genes ? testOrdered[0].genes.map(gene => gene.name) : [],
        errors: errors,
        // docNames: docNames,
        fileNames: fileNames,
        documents: test.documents,
        toDelete: state.testDetails.toDelete,
        ambryError: ambryError,
        multipleReportsShown: state.testDetails.multipleReports.show,
        blacklistFileExtensions: state.blacklistFileExtensions,
    };
    return props;
};

const mapDispatchToProps = (dispatch) => {
    return {
        onSave: () => {dispatch(actions.saveTestDetails())},
        onHide: () => dispatch(actions.showTestDetails(false)),
        saveFieldValue: (fieldId, value) => dispatch(actions.updateTestDetails(fieldId, value)),
        onLabSelected: lab => dispatch(actions.populateTestsForSelectedLab(lab)),
        onTestOrderedSelected: testOrdered => dispatch(actions.populateGenesForSelectedTest(testOrdered)),
        onTestStatusSelected: testStatus => dispatch(actions.setTestStatus(testStatus)),
        onValidationResult: (id, error) => dispatch(actions.setFieldValidationResult(id, error)),
        onDocsUploaded: files => dispatch(actions.uploadDocs(files)),
        onDocUnloaded: fileName => dispatch(actions.unloadDoc(fileName)),
        openDocument: id => dispatch(actions.openDocument(id)),
        openDocumentByUrl: id => dispatch(actions.openDocumentByUrl(id)),
        onDocDelete: (id, name) => dispatch(actions.deleteDocument(id,name,false)),
        onSeeDetails: id => dispatch(actions.showMessageBox(true, MessageBoxTypes.AMBRY_KEYS, 'medium')),
        loadBlacklistFileExtensions: () => dispatch(actions.loadBlacklistFileExtensions()),
        showMultipleReportsMessage: testId => dispatch(actions.showMessageBox(true, MessageBoxTypes.MULTIPLE_REPORTS)),
        showBlacklistUploadedFilesMessage: () => dispatch(actions.showMessageBox(true, MessageBoxTypes.BLACKLIST_FILES_UPLOADED)),
    };
};

const TestDetailsWndController = connect(
    mapStateToProps,
    mapDispatchToProps
)(TestDetailsWnd);

export default TestDetailsWndController;
